module.exports = __webpack_public_path__ + "vue-app/img/curve-green.95a3d72c.svg";